import axios from "axios";
import JwtService from "@/service/jwt.service";
import store from "./store";
import Swal from "sweetalert2";

/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
    init() {
        axios.defaults.baseURL = store.getters.domainHost;
        this.setHeader();
    },

    /**
     * Set the default HTTP request headers
     */
    setHeader() {
        axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${JwtService.getToken()}`
        axios.defaults.headers.common[
            "access-control-allow-origin"
        ] = "*"
        axios.defaults.timeout = 50000;
    },

    query(resource, params) {
        return axios.get(resource, params).catch(error => {
            console.info(error.message)
            if(error.message.indexOf('timeout') != -1 || error.message.indexOf('Network Error') != -1) {
                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success px-4",
                        cancelButton: "btn btn-danger px-4",
                    },
                    buttonsStyling: true,
                });
                swalWithBootstrapButtons.fire({
                    title: "الإتصال ضعيف",
                    text: "برجاء التأكد من الإتصال بالإنترنت",
                    icon: "warning",
                    showCancelButton: false,
                    confirmButtonText: "إعادة المحاولة",
                    reverseButtons: false,
                }) .then((result) => {
                    if(result) {
                        axios.request(error.config);
                    }
                });
            }
            throw new Error(`[KT] ApiService ${error}`);
        });
    },

    /**
     * Send the GET HTTP request
     * @param resource
     * @param slug
     * @returns {*}
     */
    get(resource, slug = "") {
        return axios.get(`${resource}/${slug}`).catch(error => {
            console.info(error.message)
            store.dispatch("setLoading", false);
            if(error.message.indexOf('timeout') != -1 || error.message.indexOf('Network Error') != -1) {
                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success px-4",
                        cancelButton: "btn btn-danger px-4",
                    },
                    buttonsStyling: true,
                });
                swalWithBootstrapButtons.fire({
                    title: "الإتصال ضعيف",
                    title: "برجاء التأكد من الإتصال بالإنترنت",
                    icon: "warning",
                    showCancelButton: false,
                    confirmButtonText: "إعادة المحاولة",
                    reverseButtons: false,
                }) .then((result) => {
                    axios.request(error.config);
                });
            }
            throw new Error(`[KT] ApiService ${error}`);
        });
    },

    /**
     * Set the POST HTTP request
     * @param resource
     * @param params
     * @returns {*}
     */
    post(resource, params, head) {
        return axios.post(`${resource}`, params, head).catch(error => {
            console.info(error.message)
            store.dispatch("setLoading", false);
            if(error.message.indexOf('timeout') != -1 || error.message.indexOf('Network Error') != -1) {
                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success px-4",
                        cancelButton: "btn btn-danger px-4",
                    },
                    buttonsStyling: true,
                });
                swalWithBootstrapButtons.fire({
                    title: "الإتصال ضعيف",
                    title: "برجاء التأكد من الإتصال بالإنترنت",
                    icon: "warning",
                    showCancelButton: false,
                    confirmButtonText: "إعادة المحاولة",
                    reverseButtons: false,
                }) .then((result) => {
                    axios.request(error.config);
                });
            }
            throw new Error(`[KT] ApiService ${error}`);
        });
    },

    /**
     * Send the UPDATE HTTP request
     * @param resource
     * @param slug
     * @param params
     * @returns {IDBRequest<IDBValidKey> | Promise<void>}
     */
    update(resource, slug, params) {
        return axios.put(`${resource}/${slug}`, params).catch(error => {
            console.info(error.message)
            if(error.message.indexOf('timeout') != -1 || error.message.indexOf('Network Error') != -1) {
                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success px-4",
                        cancelButton: "btn btn-danger px-4",
                    },
                    buttonsStyling: true,
                });
                swalWithBootstrapButtons.fire({
                    title: "الإتصال ضعيف",
                    text: "برجاء التأكد من الإتصال بالإنترنت",
                    icon: "warning",
                    showCancelButton: false,
                    confirmButtonText: "إعادة المحاولة",
                    reverseButtons: false,
                }) .then((result) => {
                    if(result) {
                        axios.request(error.config);
                    }
                });
            }
            throw new Error(`[KT] ApiService ${error}`);
        });
    },

    /**
     * Send the PUT HTTP request
     * @param resource
     * @param params
     * @returns {IDBRequest<IDBValidKey> | Promise<void>}
     */
    put(resource, params) {
        return axios.put(`${resource}`, params).catch(error => {
            console.info(error.message)
            store.dispatch("setLoading", false);
            if(error.message.indexOf('timeout') != -1 || error.message.indexOf('Network Error') != -1) {
                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success px-4",
                        cancelButton: "btn btn-danger px-4",
                    },
                    buttonsStyling: true,
                });
                swalWithBootstrapButtons.fire({
                    title: "الإتصال ضعيف",
                    text: "برجاء التأكد من الإتصال بالإنترنت",
                    icon: "warning",
                    showCancelButton: false,
                    confirmButtonText: "إعادة المحاولة",
                    reverseButtons: false,
                }) .then((result) => {
                    if(result) {
                        axios.request(error.config);
                    }
                });
            }
            throw new Error(`[KT] ApiService ${error}`);
        });
    },

    /**
     * Send the DELETE HTTP request
     * @param resource
     * @returns {*}
     */
    delete(resource) {
        return axios.delete(resource).catch(error => {
            console.info(error.message)
            store.dispatch("setLoading", false);
            if(error.message.indexOf('timeout') != -1 || error.message.indexOf('Network Error') != -1) {
                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success px-4",
                        cancelButton: "btn btn-danger px-4",
                    },
                    buttonsStyling: true,
                });
                swalWithBootstrapButtons.fire({
                    title: "الإتصال ضعيف",
                    text: "برجاء التأكد من الإتصال بالإنترنت",
                    icon: "warning",
                    showCancelButton: false,
                    confirmButtonText: "إعادة المحاولة",
                    reverseButtons: false,
                }) .then((result) => {
                    if(result) {
                        axios.request(error.config);
                    }
                });
            }
            throw new Error(`[KT] ApiService ${error}`);
        });
    }
};

export default ApiService;